import { WEEKDAY_SHORT, addDays, parseISODate, shortDate, today } from './dates';

// A weekly menu covers seven days from its start date (usually a Monday).
export const planDates = (plan) => Array.from({ length: 7 }, (_, i) => addDays(plan.week_start, i));
export const planRange = (plan) => `${shortDate(plan.week_start)} – ${shortDate(addDays(plan.week_start, 6))}`;

const weekdayShort = (iso) => WEEKDAY_SHORT[(parseISODate(iso).getDay() + 6) % 7];

// "Tuần này", "Tuần sau · bắt đầu T2", "Bắt đầu 9/11" or "Đã qua", with the chip's colours.
export const planStatus = (plan, now = today()) => {
  const end = addDays(plan.week_start, 6);
  if (end < now) return { kind: 'past', label: 'Đã qua', short: 'Đã qua', chip: 'bg-rest-bg text-rest' };
  if (plan.week_start <= now) return { kind: 'current', label: 'Tuần này', short: 'Tuần này', chip: 'bg-[#e3f1e9] text-[#17804f]' };
  const soon = plan.week_start <= addDays(now, 7);
  return {
    kind: 'upcoming',
    label: soon ? `Tuần sau · bắt đầu ${weekdayShort(plan.week_start)}` : `Bắt đầu ${shortDate(plan.week_start)}`,
    short: soon ? 'Tuần sau' : `Bắt đầu ${shortDate(plan.week_start)}`,
    chip: 'bg-[#dff1f1] text-[#1d6467]',
  };
};

export const planAverages = (plan) => {
  const days = plan.plan.days || [];
  const avg = (key) => (days.length ? days.reduce((sum, d) => sum + (d[key] || 0), 0) / days.length : null);
  return { calories: avg('total_calories'), protein: avg('total_protein_g') };
};

// Index of `iso` in the menu's week, or -1.
export const planDayIndex = (plan, iso) => planDates(plan).indexOf(iso);

// The planned dish for one slot on one date, if the menu has it.
export const plannedMeal = (plan, iso, mealType) => {
  const i = plan ? planDayIndex(plan, iso) : -1;
  return i < 0 ? null : (plan.plan.days?.[i]?.meals || []).find((m) => m.meal_type === mealType) || null;
};

// Logs a planned dish into the tracker with its kcal and protein (the menu's own AI estimate).
export const logPlannedMeal = (api, iso, meal) => api.post(`/days/${iso}/meals`, {
  meal_type: meal.meal_type,
  description: meal.description,
  calories: meal.calories,
  protein_g: meal.protein_g,
  items: JSON.stringify([{ name: meal.name, portion: meal.description, calories: meal.calories, protein_g: meal.protein_g }]),
  analysis_status: 'analyzed',
});

// A planned dish counts as logged once that day has a meal of the same name in the same slot.
export const isPlannedMealLogged = (day, meal) => !!day?.meals.some(
  (m) => m.meal_type === meal.meal_type && m.title?.toLowerCase() === meal.name.toLowerCase(),
);
